module.exports = __webpack_public_path__ + "img/section5-img.0b59a005.jpg";